import type { Tokens } from '@ovComponents/0-tokens/useTokens';
import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import {
  getSeverityFilterPillRootSx,
  severityFilterPillLabelSx,
} from './reconFlagsFilters.styles';

export type SeverityFilterPillProps = {
  label: string;
  active: boolean;
  onClick?: () => void;
  sys: Tokens['sys'];
  inactiveBorderAndText: string;
};

export const SeverityFilterPill = ({
  label,
  active,
  onClick,
  sys,
  inactiveBorderAndText,
}: SeverityFilterPillProps) => {
  const activeBg = String(sys.color.primaryPressed ?? sys.color.primary);
  const activeHoverBg = String(sys.color.primaryHover ?? activeBg);

  return (
    <Box
      component={onClick ? 'button' : 'div'}
      {...(onClick ? { type: 'button' as const } : {})}
      onClick={onClick}
      sx={getSeverityFilterPillRootSx({
        sys,
        active,
        activeBg,
        activeHoverBg,
        inactiveBorderAndText,
        interactive: Boolean(onClick),
      })}
    >
      <Typography
        component='span'
        variant='bodyMedium'
        sx={severityFilterPillLabelSx}
      >
        {label}
      </Typography>
    </Box>
  );
};
